export default "__VITE_ASSET__Cv0J1zNR__"